import { useState } from 'react'

export default function TagInput({ tags, onChange }) {
  const [input, setInput] = useState('')

  const addTag = () => {
    const t = input.trim()
    if (t && !tags.includes(t)) {
      onChange([...tags, t])
    }
    setInput('')
  }

  const removeTag = (t) => onChange(tags.filter((x) => x !== t))

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {tags.map((t) => (
          <span key={t} className="inline-flex items-center gap-1 rounded-md border border-orken-border bg-orken-bg-2 px-2 py-1 text-xs text-orken-dim">
            {t}
            <button onClick={() => removeTag(t)} className="text-orken-muted hover:text-white">×</button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addTag() } }}
          placeholder="Adicionar tag"
          className="flex-1 rounded-lg border border-orken-border bg-orken-bg-2 px-3 py-2 text-sm text-white placeholder-orken-muted focus:border-orken-accent focus:outline-none"
        />
        <button type="button" onClick={addTag} className="rounded-lg border border-orken-border px-3 py-2 text-xs font-semibold text-orken-dim hover:bg-white/5 hover:text-white transition-colors">Add</button>
      </div>
    </div>
  )
}
